import CustomButton from '../../../common/components/CustomButton';
import CustomTextArea from '../../../common/components/CustomTextAera';
import PopupContainer from '../../../common/components/PopupContainer';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeUploadForm2LyricsPopupFieldName = 'lyrics';

// 歌詞の入力（ポップアップ）
export default function KaraokeUploadForm2LyricsPopup({
  getValue,
  setValue,
  getErrors,
  onClose,
} : {
  getValue: (name: KaraokeUploadForm2LyricsPopupFieldName) => string,
  setValue: (name: KaraokeUploadForm2LyricsPopupFieldName, value: string) => void,
  getErrors: (name: KaraokeUploadForm2LyricsPopupFieldName) => FieldValidationErrorsType,
  onClose: () => void,
}) {
  return (
    <PopupContainer title="歌詞" onClose={() => onClose()}>
      <div className="list__body">
        <p className="list__addtext">
          下部のテキストボックスに歌詞を入力してください。
          <br />
          <br />
          <p className="list__addtext_item">・歌詞の内容が公序良俗に反していると判断された場合は、予告なく配信停止され返金もできませんのでご注意ください。</p>
          <br />
          <p className="list__addtext_item">
            ・カラオケで表示する歌詞以外の文字は入力しないでください。
            <br />
            <div className="list__bg">
              <b>NG例：</b>
              曲名、作詞者名、作曲者名、リピート、繰り返し、間奏、対訳、要望など
              <br />
            </div>
          </p>
          <p className="list__addtext_item">
            ・特殊な読みがある場合は、[ ] で読み方をご指定ください。
            <br />
            <div className="list__bg">
              <b>例：</b>
              私たちの運命[さだめ]ならば
              <br />
            </div>
          </p>
          <p className="list__addtext_item">・改行やスペースは指定できません。また、常用外漢字、ハートマークは使用できません。</p>
          <br />
          <p className="list__addtext_item">
            ・「パートの色分けをしたい」のオプション料金を支払われた方は、どの部分を誰が歌うのかを【 】を使って指定してください。支払われていない方は指定しても反映されません。
            <br />
            <div className="list__bg">
              <b>例：</b>
              【男】かえるのうたが【女】聞こえてくるよ
              <br />
              <b>例：</b>
              【男1】かえるの【男2】うたが【両方】聞こえてくるよ
              <br />
            </div>
          </p>
        </p>
        <div className="loader_parts_container">
          <form className="cake_ajax_form">
            <div className="form__body form__body_textarea">
              <dl>
                <dd>
                  <CustomTextArea
                    rows={5}
                    placeholder="ここに歌詞を入力してください。"
                    value={getValue('lyrics')}
                    setValue={(value) => setValue('lyrics', value)}
                    validationErrors={getErrors('lyrics')}
                  />
                  <p className="text_info_on" />
                </dd>
              </dl>
            </div>
            <ul>
              <li className="bt w100">
                <CustomButton type="default" onClick={() => onClose()}>設定する</CustomButton>
              </li>
            </ul>
          </form>
        </div>
      </div>
    </PopupContainer>
  );
}
